namespace Matrix.Data {
    export class PartyColumns {
        static columnsKey = 'Data.Party';
    }
}
